export default __webpack_public_path__ + "static/media/m3logsol.cffc7df0.jpg";